import { render, staticRenderFns } from "./combos.vue?vue&type=template&id=cd896b4e&"
import script from "./combos.vue?vue&type=script&lang=coffee&"
export * from "./combos.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports